const palette = {
  set: 'carvana',
  primary: {
    bg: {
      color: 'blue',
      normal: 'primary',
      hover: 'hover'
    },
    text: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    }
  },
  secondary: {
    bg: {
      color: 'yellow',
      normal: 'primary',
      hover: 'hover'
    },
    text: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    }
  },
  light: {
    bg: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    },
    text: {
      color: 'blue',
      normal: 'primary',
      hover: 'hover'
    },
    ghostText: {
      color: 'gray',
      hover: 'dark'
    }
  },
  disabled: {
    bg: {
      color: 'gray',
      normal: 'light'
    },
    text: {
      color: 'white',
      normal: 'primary'
    }
  }
};

export default palette;
